<template>
  <b-form-group class="notification-form-group" @notification.native="messageReceived" @change.native="clearMessage" :invalid-feedback="message" :state="state">
    <slot/>
  </b-form-group>
</template>
<style>
.notification-form-group {
  border: none;
  margin: 0;
  padding: 0;
}
</style>
<script>
export default {
  data() {
    return {
      message: '', type: ''
    }
  },
  computed: {
    state() {
      // This used to return 'valid', but that no longer shows
      if (this.type == 'success') return false;
      if (this.type == 'error') return false;
      return null;
    }
  },
  methods: {
    messageReceived(event) {
      console.log('messageReceived', event);
      let {message, type} = event.detail;
      this.message = message;
      this.type = type;
    },
    clearMessage() {
      this.message = '';
      this.type = '';
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/MessageFormGroup.vue